import { simpleFetch } from "./acCommon"

import { extractFromGeoSuggest } from "../helpers/bookingFlowHelpers"

export const FETCH_RESIDENCES = 'FETCH_RESIDENCES'
export const FETCH_RESIDENCES_REQUEST = 'FETCH_RESIDENCES_REQUEST'
export const FETCH_RESIDENCES_SUCCESS = 'FETCH_RESIDENCES_SUCCESS'
export const FETCH_RESIDENCES_FAILURE = 'FETCH_RESIDENCES_FAILURE'
export const fetchResidences = () => (dispatch, getState) => {
	let requestMeta = {
		spinnerMessageKey: 'spinner_message_fetching_residences',
	}

	dispatch(simpleFetch('/customers/residences', {
		method: 'GET'
	}, FETCH_RESIDENCES, requestMeta))
}

export const UPDATE_NEW_RESIDENCE = 'UPDATE_NEW_RESIDENCE'
export const updateNewResidence = changes => ({ type: UPDATE_NEW_RESIDENCE, changes })

export const CLEAR_NEW_RESIDENCE = 'CLEAR_NEW_RESIDENCE'
export const clearNewResidence = () => ({ type: CLEAR_NEW_RESIDENCE })

export const SELECT_RESIDENCE_FOR_ACTION = 'SELECT_RESIDENCE_FOR_ACTION'
export const selectResidenceForAction = (id) => ({ type: SELECT_RESIDENCE_FOR_ACTION, id })

export const CREATE_RESIDENCE = 'CREATE_RESIDENCE'
export const CREATE_RESIDENCE_REQUEST = 'CREATE_RESIDENCE_REQUEST'
export const CREATE_RESIDENCE_SUCCESS = 'CREATE_RESIDENCE_SUCCESS'
export const CREATE_RESIDENCE_FAILURE = 'CREATE_RESIDENCE_FAILURE'
export const createResidence = () => (dispatch, getState) => {
	let newResidence = getState().dataReducer.residences.newResidence

	let body = getResidenceBody(newResidence)

	let requestMeta = {
		spinnerMessageKey: 'spinner_message_creating_residence',
	}

	return dispatch(simpleFetch('/customers/residences', {
		method: 'POST',
		body: body
	}, CREATE_RESIDENCE, requestMeta)).then(({ actionType, response, requestMeta }) => {
		if (actionType === CREATE_RESIDENCE_SUCCESS) {
			dispatch(this.fetchResidences())
			dispatch(this.clearNewResidence())
		}

		return { actionType, response, requestMeta }
	})
}

export const prefillNewResidence = (suggestion) => (dispatch, getState) => {
	let changes = {
		streetName: extractFromGeoSuggest('route', suggestion),
		streetNumber: extractFromGeoSuggest('street_number', suggestion),
		zipCode: extractFromGeoSuggest('postal_code', suggestion),
		city: extractFromGeoSuggest('locality', suggestion)
	}

	dispatch(this.updateNewResidence(changes))
}

export const UPDATE_RESIDENCE = 'UPDATE_RESIDENCE'
export const UPDATE_RESIDENCE_REQUEST = 'UPDATE_RESIDENCE_REQUEST'
export const UPDATE_RESIDENCE_SUCCESS = 'UPDATE_RESIDENCE_SUCCESS'
export const UPDATE_RESIDENCE_FAILURE = 'UPDATE_RESIDENCE_FAILURE'

export const updateResidence = () => (dispatch, getState) => {
	let newResidence = getState().dataReducer.residences.newResidence

	let body = getResidenceBody(newResidence)

	let requestMeta = {
		spinnerMessageKey: 'spinner_message_updating_residence',
	}

	return dispatch(simpleFetch('/customers/residences/' + newResidence.id, {
		method: 'PUT',
		body: body
	}, UPDATE_RESIDENCE, requestMeta)).then(({ actionType, response, requestMeta }) => {
		if (actionType === UPDATE_RESIDENCE_SUCCESS) {
			dispatch(this.fetchResidences())
			dispatch(this.clearNewResidence())
		}
	})
}

export const DELETE_RESIDENCE = 'DELETE_RESIDENCE'
export const DELETE_RESIDENCE_REQUEST = 'DELETE_RESIDENCE_REQUEST'
export const DELETE_RESIDENCE_SUCCESS = 'DELETE_RESIDENCE_SUCCESS'
export const DELETE_RESIDENCE_FAILURE = 'DELETE_RESIDENCE_FAILURE'
export const deleteResidence = () => (dispatch, getState) => {
	let residences = getState().dataReducer.residences

	let residenceToDeleteID = residences.residenceToDeleteID

	let requestMeta = {
		spinnerMessageKey: 'spinner_message_deleting_residence',
	}

	return dispatch(simpleFetch('/customers/residences/' + residenceToDeleteID, {
		method: 'DELETE',
	}, DELETE_RESIDENCE, requestMeta)).then(({ actionType, response, requestMeta }) => {
		if (actionType === DELETE_RESIDENCE_SUCCESS) {
			dispatch(this.fetchResidences())
		}
	})
}

const getResidenceBody = (newResidence) => {
	return JSON.stringify({
		residence_type: newResidence.type,
		surface: newResidence.surface,
		pets: newResidence.hasPets,
		how_to_get_in: newResidence.howToGetIn,
		other_info: newResidence.otherInfo,
		address: {
			street_name: newResidence.streetName,
			street_number: newResidence.streetNumber,
			street_box: newResidence.streetBox,
			zip_code: newResidence.zipCode,
			town: newResidence.city
		}
	})
}


// WEBPACK FOOTER //
// ./src/actions/acResidences.js